import { useEffect, useReducer } from 'react'
import { AnyAction } from 'redux'
import { GET_CANCEL_DETAIL, CHECK_ORDER_CANCEL } from '../../api/Cancel'
import { GetLocalStorage, isResponseCodeSuccess } from '../../tools/util'
import { fileFile } from '../../modules/goodsdetailmodules/uploadfilesBrand'
import { message, Form } from 'antd'
import { useQuery } from '../../tools/utilHooks'
// action 类型定义
const RETURNORDER_ACTION_TYPE = {
  CHANGE_MODAL: 'VISIBLE', // 弹窗
  SET_INFODATE: 'SET_INFODATE',
  SET_PRODUCT_LIST: 'SET_PRODUCT_LIST',
  SET_UN_PRODUCT_LIST: 'SET_UN_PRODUCT_LIST',
}

interface LicenceInfo {
  baseUrl: string
  cooperationAgreementState: string
  cooperationAgreementUrl: string
}
interface CooperationState {
  visible: boolean
  licenceInfo: LicenceInfo
  fileList: fileFile[]
  uploadParams: { code: string; type: string }
  infoObj: any
  uploadfilesList: any[]
  dataSource: any[]
  isTableLoading: false
  productList: any[]
}
const defaultState: CooperationState = {
  visible: false,
  licenceInfo: {
    baseUrl: '',
    cooperationAgreementState: '',
    cooperationAgreementUrl: '',
  },
  fileList: [],
  uploadParams: {
    code: GetLocalStorage('SUPPLIER_CODE'),
    type: 'supplier',
  },
  infoObj: {},
  uploadfilesList: [],
  dataSource: [],
  isTableLoading: false,
  productList: [],
}

// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case RETURNORDER_ACTION_TYPE.CHANGE_MODAL:
      arr.visible = action.value
      return arr
    case RETURNORDER_ACTION_TYPE.SET_INFODATE:
      arr.infoObj = action.value
      return arr
    case RETURNORDER_ACTION_TYPE.SET_PRODUCT_LIST:
      arr.dataSource = action.value
      return arr
    case RETURNORDER_ACTION_TYPE.SET_UN_PRODUCT_LIST:
      arr.productList = action.value
      return arr
    default:
      return state
  }
}

//
const changeVisible = (params: boolean) => ({
  type: RETURNORDER_ACTION_TYPE.CHANGE_MODAL,
  value: params,
})
const setInfoDateAction = (params: any) => ({
  type: RETURNORDER_ACTION_TYPE.SET_INFODATE,
  value: params,
})
const setProductListAction = (params: any[]) => ({
  type: RETURNORDER_ACTION_TYPE.SET_PRODUCT_LIST,
  value: params,
})
const setUnDeliverProductListAction = (params: any[]) => ({
  type: RETURNORDER_ACTION_TYPE.SET_UN_PRODUCT_LIST,
  value: params,
})

const useCooperationHooks = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const [form] = Form.useForm()
  const { visible, infoObj, dataSource, isTableLoading, productList } = state
  useEffect(() => {
    getInfo()
    // eslint-disable-next-line
  }, [])
  const query = useQuery()
  const getInfo = async () => {
    const id = query.get('id') || ''
    const res = await GET_CANCEL_DETAIL({ orderReturnId: id })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setInfoDateAction(res.data))
      dispatch(setProductListAction(res.data.productList))
      dispatch(setUnDeliverProductListAction(res.data.unDeliveryProductList))
    }
  }

  const agreeReturnGoods = async () => {
    const data = { isPass: '1', orderReturnId: infoObj.id }
    const res = await CHECK_ORDER_CANCEL({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      getInfo()
    }
  }
  const rejectReturnGoods = () => {
    dispatch(changeVisible(true))
  }
  const hideModal = () => {
    dispatch(changeVisible(false))
  }
  const okModal = async () => {
    const data = await form.validateFields()
    const res = await CHECK_ORDER_CANCEL({
      isPass: '2',
      orderReturnId: infoObj.id,
      reason: data.reason,
    })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      hideModal()
      getInfo()
    }
  }

  return {
    visible,
    hideModal,
    infoObj,
    form,
    dataSource,
    isTableLoading,
    agreeReturnGoods,
    rejectReturnGoods,
    okModal,
    productList,
  }
}

export default useCooperationHooks
import { useEffect, useReducer } from 'react'
import { AnyAction } from 'redux'
import { GET_CANCEL_DETAIL, CHECK_ORDER_CANCEL } from '../../api/Cancel'
import { GetLocalStorage, isResponseCodeSuccess } from '../../tools/util'
import { fileFile } from '../../modules/goodsdetailmodules/uploadfilesBrand'
import { message, Form } from 'antd'
import { useQuery } from '../../tools/utilHooks'
// action 类型定义
const RETURNORDER_ACTION_TYPE = {
  CHANGE_MODAL: 'VISIBLE', // 弹窗
  SET_INFODATE: 'SET_INFODATE',
  SET_PRODUCT_LIST: 'SET_PRODUCT_LIST',
  SET_UN_PRODUCT_LIST: 'SET_UN_PRODUCT_LIST',
}

interface LicenceInfo {
  baseUrl: string
  cooperationAgreementState: string
  cooperationAgreementUrl: string
}
interface CooperationState {
  visible: boolean
  licenceInfo: LicenceInfo
  fileList: fileFile[]
  uploadParams: { code: string; type: string }
  infoObj: any
  uploadfilesList: any[]
  dataSource: any[]
  isTableLoading: false
  productList: any[]
}
const defaultState: CooperationState = {
  visible: false,
  licenceInfo: {
    baseUrl: '',
    cooperationAgreementState: '',
    cooperationAgreementUrl: '',
  },
  fileList: [],
  uploadParams: {
    code: GetLocalStorage('SUPPLIER_CODE'),
    type: 'supplier',
  },
  infoObj: {},
  uploadfilesList: [],
  dataSource: [],
  isTableLoading: false,
  productList: [],
}

// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case RETURNORDER_ACTION_TYPE.CHANGE_MODAL:
      arr.visible = action.value
      return arr
    case RETURNORDER_ACTION_TYPE.SET_INFODATE:
      arr.infoObj = action.value
      return arr
    case RETURNORDER_ACTION_TYPE.SET_PRODUCT_LIST:
      arr.dataSource = action.value
      return arr
    case RETURNORDER_ACTION_TYPE.SET_UN_PRODUCT_LIST:
      arr.productList = action.value
      return arr
    default:
      return state
  }
}

//
const changeVisible = (params: boolean) => ({
  type: RETURNORDER_ACTION_TYPE.CHANGE_MODAL,
  value: params,
})
const setInfoDateAction = (params: any) => ({
  type: RETURNORDER_ACTION_TYPE.SET_INFODATE,
  value: params,
})
const setProductListAction = (params: any[]) => ({
  type: RETURNORDER_ACTION_TYPE.SET_PRODUCT_LIST,
  value: params,
})
const setUnDeliverProductListAction = (params: any[]) => ({
  type: RETURNORDER_ACTION_TYPE.SET_UN_PRODUCT_LIST,
  value: params,
})

const useCooperationHooks = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const [form] = Form.useForm()
  const { visible, infoObj, dataSource, isTableLoading, productList } = state
  useEffect(() => {
    getInfo()
    // eslint-disable-next-line
  }, [])
  const query = useQuery()
  const getInfo = async () => {
    const id = query.get('id') || ''
    const res = await GET_CANCEL_DETAIL({ orderReturnId: id })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setInfoDateAction(res.data))
      dispatch(setProductListAction(res.data.productList))
      dispatch(setUnDeliverProductListAction(res.data.unDeliveryProductList))
    }
  }

  const agreeReturnGoods = async () => {
    const data = { isPass: '1', orderReturnId: infoObj.id }
    const res = await CHECK_ORDER_CANCEL({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      getInfo()
    }
  }
  const rejectReturnGoods = () => {
    dispatch(changeVisible(true))
  }
  const hideModal = () => {
    dispatch(changeVisible(false))
  }
  const okModal = async () => {
    const data = await form.validateFields()
    const res = await CHECK_ORDER_CANCEL({
      isPass: '2',
      orderReturnId: infoObj.id,
      reason: data.reason,
    })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      hideModal()
      getInfo()
    }
  }

  return {
    visible,
    hideModal,
    infoObj,
    form,
    dataSource,
    isTableLoading,
    agreeReturnGoods,
    rejectReturnGoods,
    okModal,
    productList,
  }
}

export default useCooperationHooks
